import { action, makeAutoObservable } from 'mobx';
import { ParticipantsType, SdkStaff } from 'src/AppState/sdk/staff';
import { MobxMap } from 'src_common/common/mobx-utils/MobxMap';
import { isNewParticipant, NewParticipantResponseType } from './EventActionsStateTypes';
import {
    OpenapiProxyStaffEventMarketUpdateParamsType,
    openapiProxyStaffEventMarketUpdateRequest,
} from 'src/api_openapi/generated/openapi_proxy_staff_event_market_update';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export type MarketUpdateBodyType = OpenapiProxyStaffEventMarketUpdateParamsType['requestBody'];

export class EventStateActions {
    public readonly participantsData: MobxMap<[string, string], ParticipantsType>;

    constructor(private readonly sdkStaff: SdkStaff) {
        this.participantsData = new MobxMap(async ([sport, name]: [string, string]): Promise<ParticipantsType> => {
            return await sdkStaff.getParticipants({
                requestBody: {
                    sport,
                    ngram: name,
                },
            });
        });
        makeAutoObservable(this);
    }

    @action saveMarketChanges = async (
        marketId: MarketId,
        data: MarketUpdateBodyType,
        triggerUpdate: boolean = false
    ): Promise<void> => {
        const eventId = marketId.getEventId();

        const params: OpenapiProxyStaffEventMarketUpdateParamsType = {
            event_id: eventId.toOldId(),
            market_id: marketId.toOldId(),
            requestBody: data,
        };

        await this.sdkStaff.session.call(openapiProxyStaffEventMarketUpdateRequest, params);

        if (triggerUpdate === true) {
            await this.sdkStaff.triggerUpdateEvent(eventId);
            await this.sdkStaff.triggerUpdateMarket(marketId);
        }
    };

    @action createParticipant = async (data: {
        name: string;
        sport: string;
        isCreation: boolean;
    }): Promise<NewParticipantResponseType> => {
        const response = await this.sdkStaff.createParticipant({ requestBody: data });

        if (isNewParticipant(response)) {
            return {
                status: 'success',
                value: response,
            };
        }

        console.error('Can not create new participant', response);

        return {
            status: 'error',
            message: 'Can not create new participant',
        };
    };

    @action triggerUpdateEvent = async (eventId: EventId): Promise<void> => {
        await this.sdkStaff.triggerUpdateEvent(eventId);
    };

    @action triggerUpdateMarket = async (marketId: MarketId): Promise<void> => {
        await this.sdkStaff.triggerUpdateMarket(marketId);
    };
}
